import store from '@/store';
import Vue from 'vue';

const resourcesGuard = async (to, from, next) => {
  try {
    // Wait for feature flags to load
    if (!store.getters['BusinessStore/featureFlagsLoaded']) {
      await new Promise((resolve) => {
        const unwatch = store.watch(
          (state, getters) => getters['BusinessStore/featureFlagsLoaded'],
          (loaded) => {
            if (loaded) {
              unwatch();
              resolve();
            }
          },
        );
        // Timeout after 5 seconds as fallback
        setTimeout(() => {
          unwatch();
          resolve();
        }, 5000);
      });
    }

    // Check feature flags
    const hasResources = Vue.prototype.$hasFeature('resources');
    const hasPkgSchResources = Vue.prototype.$hasFeature('pkg.sch.resources');

    // Check permission asynchronously
    const permissionResults = await Vue.prototype.$hasPermissionsAsync(['account.settings.manage']);
    const hasSettingsPermission = permissionResults['account.settings.manage'] || false;

    // Determine if this is a details page
    const isDetailsPage = to.path.includes('/:') || to.params.uid;

    // Access requirements based on page type
    const hasAccess = isDetailsPage
      ? hasResources && hasPkgSchResources && hasSettingsPermission // Details: require both FFs
      : hasResources && hasSettingsPermission; // Main: rollout FF only (upgrade flow)

    if (hasAccess) {
      return next();
    }

    // Special handling for details page: redirect to main page if user has rollout FF but not packageable (upgrade flow)
    if (isDetailsPage && hasResources && hasSettingsPermission && !hasPkgSchResources) {
      return next('/settings/resources');
    }

    // Use the same pattern as the main router for unauthorized access
    return next({ name: 'userError', params: { errorType: 'unauthorised' } });
  } catch (error) {
    console.error('Error in resources guard:', error);
    return next({ name: 'userError', params: { errorType: 'unauthorised' } });
  }
};

const routes = [
  {
    path: '/settings/resources',
    component: () => import(/* webpackChunkName: "ResourcesSettings" */ './views/ResourcesSettingsPage.vue'),
    name: 'resources-settings',
    props: (route) => ({ ...route.query }),
    meta: { i18n: 'resources-settings-pov', pageNameEn: 'Resources Settings' },
    beforeEnter: resourcesGuard,
  },
  {
    path: '/settings/resources/:uid',
    component: () => import(/* webpackChunkName: "ResourcePage" */ './views/ResourcePage.vue'),
    name: 'resource-type-details',
    props: true,
    meta: { i18n: 'resources-settings-pov', pageNameEn: 'Resource Details' },
    beforeEnter: resourcesGuard,
  },
];

export default routes;
